import React, { useState } from "react";
import axios from "axios";
import * as XLSX from "xlsx";
import { getToken, base_url } from "../../config/config";

const AddFirma = () => {
  const [formData, setFormData] = useState({
    konto: "",
    bezeichnung: "",
    kurzbezeichnung: "",
    ustIdNummer: "",
  });
  const [file, setFile] = useState(null);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(`${base_url}/v1/addFirma`, formData);
      alert("Firma added successfully!");
      setFormData({
        konto: "",
        bezeichnung: "",
        kurzbezeichnung: "",
        ustIdNummer: "",
      });
    } catch (error) {
      alert(
        "Error adding firma: " +
          (error.response?.data?.message || "Unknown error"),
      );
    }
  };

  const handleBulkUpload = async () => {
    if (!file) {
      alert("Please select a file first.");
      return;
    }

    const reader = new FileReader();
    reader.onload = async (event) => {
      const data = new Uint8Array(event.target.result);
      const workbook = XLSX.read(data, { type: "array" });
      const worksheet = workbook.Sheets[workbook.SheetNames[0]];
      const jsonData = XLSX.utils.sheet_to_json(worksheet);

      const validData = jsonData.map((entry) => ({
        konto: entry.Konto || "",
        bezeichnung: entry.Bezeichnung || "",
        kurzbezeichnung: entry.Kurzbezeichnung || "",
        ustIdNummer: entry.UStIDNummer || "",
      }));

      try {
        const response = await axios.post(`${base_url}/v1/addFirma`, validData);
        alert("Bulk upload successful!");
        setFile(null);
      } catch (error) {
        console.error("Bulk upload error:", error.response || error);
        alert(
          "Error uploading bulk data: " +
            (error.response?.data?.message || "Unknown error"),
        );
      }
    };
    reader.readAsArrayBuffer(file);
  };

  const containerStyle = {
    maxWidth: "600px",
    margin: "0 auto",
    padding: "20px",
    border: "1px solid #ccc",
    borderRadius: "8px",
    boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
    backgroundColor: "#f9f9f9",
  };

  const formStyle = {
    display: "flex",
    flexDirection: "column",
    gap: "15px",
  };

  const inputStyle = {
    padding: "10px",
    fontSize: "16px",
    borderRadius: "4px",
    border: "1px solid #ccc",
  };

  const buttonStyle = {
    padding: "10px",
    fontSize: "16px",
    borderRadius: "4px",
    border: "none",
    backgroundColor: "#007bff",
    color: "white",
    cursor: "pointer",
  };

  const labelStyle = {
    fontWeight: "bold",
  };

  return (
    <div style={containerStyle}>
      <h1 style={{ textAlign: "center" }}>Add Firma</h1>
      <form onSubmit={handleSubmit} style={formStyle}>
        <div>
          <label style={labelStyle}>Konto:</label>
          <input
            type='text'
            name='konto'
            value={formData.konto}
            onChange={handleInputChange}
            required
            style={inputStyle}
          />
        </div>
        <div>
          <label style={labelStyle}>Bezeichnung:</label>
          <input
            type='text'
            name='bezeichnung'
            value={formData.bezeichnung}
            onChange={handleInputChange}
            required
            style={inputStyle}
          />
        </div>
        <div>
          <label style={labelStyle}>Kurzbezeichnung:</label>
          <input
            type='text'
            name='kurzbezeichnung'
            value={formData.kurzbezeichnung}
            onChange={handleInputChange}
            required
            style={inputStyle}
          />
        </div>
        <div>
          <label style={labelStyle}>USt-IdNr:</label>
          <input
            type='text'
            name='ustIdNummer'
            value={formData.ustIdNummer}
            onChange={handleInputChange}
            required
            style={inputStyle}
          />
        </div>
        <button type='submit' style={buttonStyle}>
          Add Firma
        </button>
      </form>

      <h2 style={{ textAlign: "center" }}>Bulk Upload</h2>
      <input
        type='file'
        accept='.xlsx, .xls'
        onChange={handleFileChange}
        style={{ margin: "20px 0" }}
      />
      <button onClick={handleBulkUpload} style={buttonStyle}>
        Upload
      </button>
    </div>
  );
};

export default AddFirma;
